export const invalidPermlink = /^-|[^a-zA-Z0-9-]/;

export const instagramPost = /(?:http[s]?:\/\/)?(?:www.)?instagram\.com\/(?:p|reel)\/(.*)\//gi;

export const swmregex = /!\b(?:steemitworldmap|pinmapple)\b\s((?:[-+]?(?:[1-8]?\d(?:\.\d+)?|90(?:\.0+)?)))\s\blat\b\s((?:[-+]?(?:180(?:\.0+)?|(?:(?:1[0-7]\d)|(?:[1-9]?\d))(?:\.\d+)?)))\s\blong\b/gi;

export const tfJSON = /<div json='{(.*)}'>(.*)<\/div>/;

// eslint-disable-next-line no-control-regex
export const allSpecialChars = /(?:[!/:-@[-`{-~],.|[^\x00-\x7F]|\s)/g;

export const postUrl = /https:\/\/(?:travelfeed\.com|travelfeed\.io|steemit\.com|busy\.org|steempeak\.com|partiko\.app)(?:\/|\/[a-z0-9-]{1,30}\/)@([a-z0-9-]{3,16})\/([a-z0-9-]*)/i;

export const mentionUrl = /^(?:https:\/\/(?:travelfeed\.com|travelfeed\.io|steemit\.com|busy\.org|steempeak\.com|partiko\.app)|)\/@([a-z0-9-]{3,16})$/i;

export const exitUrl = /^\/exit\?url=(.*)$/i;

export const threespeakUrl = /^https%3A%2F%2F3speak\.tv%2Fwatch%3Fv%3D(.*)%2F(.*)/i;

export const validTwitterUsername = /^@?(\w){1,15}$/;
export const validFacebookUsername = /^[a-z\d.]{5,}$/i;
export const validInstagramUsername = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,30}$/;
export const validPinterestUsername = /^[a-z\d._]{2,30}$/i;
